import type React from 'react';

import { BodyRegular } from 'components/typography/Typography';

interface DoublesDataDisplayProps {
  data: string[];
  className?: string;
}

export const DoublesDataDisplay: React.FC<React.PropsWithChildren<DoublesDataDisplayProps>> = ({ data, className }) => {
  return (
    <>
      {Array.isArray(data) &&
        data?.map((item, i) => {
          return (
            <BodyRegular key={i} className={className}>
              {item}
            </BodyRegular>
          );
        })}
    </>
  );
};
